module.exports = __webpack_public_path__ + "img/arrow-right-purple.00531d03.svg";